import React from 'react'

function SinglePortfolio(props) {
    var github = props?.github
    if ( github !=''){
        github = 'GitHub Link'
    }else{github = ''}
  return (
    <div data-aos="fade-up" data-aos-duration="800" >
        <a href={props.url} target='blank' >
            <div className='single-portfolio-wrapper' >
                <div className="single-portfolio-img">
                    <img src={props.img} alt=""  />
                </div>
                <div className="single-portfolio-title d-flex">
                    <h3>{props.name}</h3>
                </div>
            </div>
        </a>
        <div className="project-link d-flex">
            <div><a href={props?.github} target='blank'>{github}</a></div>
            <div><a href={props.url} target='blank'>Live Link</a></div>
        </div>
    </div>
  )
}

export default SinglePortfolio